module.exports = __webpack_public_path__ + "img/fm.bb808be1.png";